// extracted by mini-css-extract-plugin
export default {"button":"Button_button__qk-eM","isDisabledButton":"Button_isDisabledButton__sYcAm","loading":"Button_loading__XDNs6"};